// Delegation also handles sections reloaded by the Shopify theme editor.
function updateHaleemNavigation() {
  document.querySelectorAll('.nav a').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.pathname === location.pathname && !url.hash) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
}
document.addEventListener('DOMContentLoaded', updateHaleemNavigation);
document.addEventListener('shopify:section:load', updateHaleemNavigation);
document.addEventListener('click', event => {
  if (event.target.closest('.nav a')) {
    const toggle = document.querySelector('.nav-toggle');
    if (toggle) toggle.checked = false;
  }
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    const toggle = document.querySelector('.nav-toggle');
    if (toggle && toggle.checked) { toggle.checked = false; toggle.focus(); }
  }
});
